<template>
  <Stage class="instructions">
    <template #header>
      <h1>{{ trialData.header.headline.text }}</h1>
      <p>{{ trialData.header.content.text }}</p>
    </template>
    <InstructionsContainer>
      <FillImage
        :src="image"
        :imageCache="imageCache"
        :alt="`logo for ${trialData.header.headline.text}`"
      />
    </InstructionsContainer>
  </Stage>
</template>

<script>
import { Stage } from '@neurotrack/web-shared-components'
import essComponentProps from '@/mixins/essComponentProps'
import InstructionsContainer from '@/components/InstructionsContainer'
import FillImage from '@/components/FillImage'

export default {
  name: 'instructions_header_image',
  components: { Stage, InstructionsContainer, FillImage },
  mixins: [essComponentProps],
  computed: {
    image() {
      return this.trialData?.body?.image?.filename
    }
  }
}
</script>

<style scoped>
.instructions-container {
  display: flex;
  align-items: center;
  width: 100%;
}
img {
  flex: 1;
  width: 100%;
  height: auto;
}
</style>
